import { render, staticRenderFns } from "./personEnterAndExit.vue?vue&type=template&id=b42ae960&scoped=true&"
import script from "./personEnterAndExit.vue?vue&type=script&lang=js&"
export * from "./personEnterAndExit.vue?vue&type=script&lang=js&"
import style0 from "./personEnterAndExit.vue?vue&type=style&index=0&id=b42ae960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42ae960",
  null
  
)

export default component.exports